// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import X from "@insite/mobius/Icons/X";
import cartLineSharedStyles from "@sc/App/SharedStyles/CartLineSharedStyles";
import { discontinuedProductListLineStyles } from "@sc/Overrides/Widgets/MyListsDetails/MyListDetailsDiscontinuedProductListLine";
import { fontConfig } from "@sc/XDL/PreStyle/typography";
import { ellipsis, mergeWithCss, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

discontinuedProductListLineStyles.restrictedDescriptionText = {
    size: 14,
    weight: fontConfig.weight.bold,
    css: css`
        line-height: 16px;
        margin-bottom: 18px;
        ${xScreen("lte", "md")} {
            font-size: 12px;
            line-height: 13px;
        }
        ${ellipsis(2)}
    `,
};

discontinuedProductListLineStyles.productPartNumbersStyles = {
    ...mergeWithCss(cartLineSharedStyles.productPartNumbers, {
        container: {
            css: css`
                margin-bottom: 0;
            `,
        },
    }),
};

discontinuedProductListLineStyles.deleteLink = {
    icon: {
        iconProps: {
            src: X,
            size: 12,
        },
    },
};
